import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import ReactDOM from 'react-dom';
import './i18n';
import { ReactQueryConfigProvider } from 'react-query';
import { ToursApp } from './App.Tours';
// import registerServiceWorker from './registerServiceWorker';

if (process.env.NODE_ENV === 'production') window.dataLayer = window.dataLayer || [];

const rootElement = document.getElementById('react-container');

ReactDOM.render(
  <ReactQueryConfigProvider config={{ refetchAllOnWindowFocus: false }}>
    <ToursApp />
  </ReactQueryConfigProvider>, rootElement);

// registerServiceWorker();

const viewportMeta = document.querySelector('meta[name="viewport"]') as HTMLMetaElement;
viewportMeta.content = viewportMeta.content.replace(/width=[^,]*/, 'width=device-width');
